import { render, staticRenderFns } from "./ForgotReset.vue?vue&type=template&id=65214a30&"
import script from "./ForgotReset.vue?vue&type=script&lang=js&"
export * from "./ForgotReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports